import { useLanguage } from "../../i18n/LanguageContext";

interface Props { round: number; totalRounds: number; costOfLiving: number; }

export default function RoundTracker({ round, totalRounds, costOfLiving }: Props) {
  const { t } = useLanguage();
  const progress = ((round - 1) / totalRounds) * 100;
  return (
    <div className="bg-slate-800/80 rounded-2xl border border-white/10 p-3 space-y-2">
      <div className="flex justify-between items-center">
        <span className="text-white/60 text-sm font-display font-semibold">{t.board.round}</span>
        <span className="font-display font-black text-white text-lg">{round} / {totalRounds}</span>
      </div>
      <div className="w-full h-2 bg-white/10 rounded-full overflow-hidden">
        <div className="h-full bg-gradient-to-r from-earnings to-purple-500 rounded-full transition-all duration-500" style={{ width: `${progress}%` }} />
      </div>
      <div className="text-xs text-white/40 text-center">
        {t.board.costOfLiving} <span className="text-red-400 font-bold">🪙{costOfLiving}</span> {t.board.perTurn}
      </div>
    </div>
  );
}
